import _jsx from "@babel/runtime/helpers/jsx";
import React from 'react';
import { Label } from 'reaxl';
import { useFeatures } from 'reaxl-features';

/**
 *  Renders a battery health badge for use in InventoryListingBadges
 */
function BatteryHealthBadge(_ref) {
  let {
    healthDescription,
    manufacturer,
    ratingSource,
    healthRating
  } = _ref;
  const {
    battery_health: [, {
      health_rating_threshold: minimumHealthRating,
      ford_battery_health: fordBatteryHealth
    }]
  } = useFeatures(['battery_health']);
  if (!healthDescription) return null;
  const isFordOEM = ratingSource === 'OEM' && manufacturer === 'Ford';
  const isManheim = ratingSource === 'Manheim';
  const validRatingSource = isManheim || isFordOEM;
  const showBatteryHealth = validRatingSource && (fordBatteryHealth && healthRating >= minimumHealthRating || !fordBatteryHealth);
  return showBatteryHealth && /*#__PURE__*/_jsx(Label, {
    bsStyle: "info-inverse",
    "data-cmp": "batteryHealthBadge"
  }, void 0, `${healthDescription[0].toUpperCase() + healthDescription.slice(1).toLowerCase()} Battery Health`);
}
export default BatteryHealthBadge;